import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const submitDemo = (payload) => api.post("/demo", payload).then((r) => r.data);
export const fetchJobs = () => api.get("/careers").then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
